import React from 'react';
import { RadioGroup, Radio } from '@alfa-retail-react/components';
import { observer } from 'mobx-react';

import { WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { getDividedCardHolderName, getWithShortName, getWithShortSurname } from 'app/utils/StringUtils';
import { OrderPageStore } from 'app/logic/pages/order/OrderPageStore';

export interface SmartEngFullNameFormItemsProps {
    /**
     * Стор страницы.
     */
    pageStore: OrderPageStore;
}

/**
 * Компонент для отображения выборта имени и фамилии на латинице на карточке.
 */
export const SmartEngFullNameFormItems = observer(
    ({ pageStore }: SmartEngFullNameFormItemsProps) => {
        const withShortName = getWithShortName(
            pageStore.orderFormStore.name,
            pageStore.orderFormStore.surname,
        );
        const withShortNameLabel = getDividedCardHolderName(withShortName);

        const withShortSurname = getWithShortSurname(
            pageStore.orderFormStore.name,
            pageStore.orderFormStore.surname,
        );
        const withShortSurnameLabel = getDividedCardHolderName(withShortSurname);

        /**
         * Действие, выполняемое при выборе одного из варианта сокращения имени и фамилии
         * @param e нативный html event
         * @param { value } значение инпута
         */
        const changeCardHolderName = (
            e:
                | React.ChangeEvent<Element>
                | React.MouseEvent<Element, MouseEvent>,
            { value }: { value: string },
        ) => {
            pageStore.orderFormStore.setCardHolder(value);
        };

        return (
            <RadioGroup
                name="radioGroup"
                className={WEB_VISOR_HIDE}
                value={pageStore.orderFormStore.cardHolder}
                onChange={changeCardHolderName}
            >
                <Radio value={withShortName} label={withShortNameLabel} />
                <Radio value={withShortSurname} label={withShortSurnameLabel} />
            </RadioGroup>
        );
    },
);
